import { Middleware } from '@nuxt/types'

const guard: Middleware = ({ $auth, $config }) => {
  if (!process.client) {
    return
  }

  if (!$config.useExternalLoginUi) {
    return
  }

  if (!$auth.loggedIn) {
    const redirectUrl = new URL('/registration/login', window.location.href)
    redirectUrl.searchParams.set('redirect', window.location.href)
    window.location.href = redirectUrl.href
  }
}

export default guard
